import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getNihClinGenVariantsData } from "../../../../state/selectors/NihClinGenVariants.selectors";
import Criteria from "./components/Criteria";
import TitleDetails from "./components/TitleDetails";
import Summary from "./components/Summary";
import InformationTable from "./components/InformationTable";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import HelperText from "../../../../components/atoms/HelperText";

const NihClinGenVariants = (props) => {
  const { nihClinGenVariantsData } = props;

  if (!nihClinGenVariantsData) return null;

  const tmpl = nihClinGenVariantsData.map((item, index) => {
    const { version, repo_link: clingenRepoUrl } = item;
    return (
      <div key={index} className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={
              <React.Fragment>
                <a
                  href={getVarsoUrl("https://clinicalgenome.org/")}
                  target="_blank"
                >
                  ClinGen
                </a>
                <HelperText fieldDescriptionKey="ClinGen" />
              </React.Fragment>
            }
            version={version}
            titleDetailsRight={<TitleDetails clingenRepoUrl={clingenRepoUrl} />}
            content={
              <React.Fragment>
                <InformationTable item={item} />
                <Criteria item={item} criteriaMet={true} />
                <Criteria item={item} criteriaMet={false} />
                <Summary item={item} />
              </React.Fragment>
            }
          />
        </div>
      </div>
    );
  });

  return tmpl;
};

NihClinGenVariants.propTypes = {
  nihClinGenVariantsData: PropTypes.arrayOf(
    PropTypes.shape({
      approval_date: PropTypes.string,
      disease: PropTypes.string,
      evidence_met: PropTypes.arrayOf(PropTypes.string),
      evidence_not_met: PropTypes.arrayOf(PropTypes.string),
      expert_panel: PropTypes.string,
      guideline: PropTypes.string,
      mode_of_inheritance: PropTypes.string,
      mondo_id: PropTypes.string,
      pathogenicity: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.string),
      published_date: PropTypes.string,
      repo_link: PropTypes.string,
      retracted: PropTypes.string,
      summary: PropTypes.string,
      version: PropTypes.string,
    })
  ),
};

NihClinGenVariants.defaultProps = {
  nihClinGenVariantsData: [],
};

const mapStateToProps = (state) => ({
  nihClinGenVariantsData: getNihClinGenVariantsData(state),
});

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(NihClinGenVariants, "ClinGen Variants", "ClinGen"));
